import { useComposerMentionsSync } from './useComposerMentionsSync.js'
import { useComposerMentionsInsert } from './useComposerMentionsInsert.js'

export function useComposerMentions(editor, enableMentions, mentionMembers, mentionAgents, refs) {
  const { mentionUsers, mentionAgentsList, mentionFlatCount, syncMentionUi } = useComposerMentionsSync(
    editor,
    enableMentions,
    mentionMembers,
    mentionAgents,
    refs,
  )
  const { insertMention } = useComposerMentionsInsert(
    editor,
    refs,
    mentionUsers,
    mentionAgentsList,
    mentionFlatCount,
  )
  return { mentionUsers, mentionAgentsList, syncMentionUi, insertMention }
}
